import React from "react";
import { Link } from "@quintype/components";
import get from "lodash/get";
import { string, object, bool } from "prop-types";

import { getHeadline } from "../../utils/utils";

import SponsoredIcon from "../../atoms/icons/Sponsored";

import "./newsHeadline.m.css";

const NewsHeadline = ({
  cssStyleName,
  story = {},
  showDot = false,
  styles = {},
  showSubHeading = true,
  linkEnable = true,
  Htag = "h3",
}) => {
  const sponsorId = get(story, ["metadata", "story-attributes", "sponsoredby", "0", "id"], null);
  const storyHeadline = getHeadline(story);

  return (
    <Htag styleName={`title ${cssStyleName || ""}`} className={`headline-title ${sponsorId ? "sponsor-title" : ""}`}>
      {showDot && styles && (
        <span styleName="s-dot" style={{ background: styles.dotColor.color !== "4d" ? styles.dotColor.color : "#ccc" }}>
          &nbsp;
        </span>
      )}

      {sponsorId && <SponsoredIcon />}
      {linkEnable ? (
        <Link aria-label={story.subheadline || "Title link"} href={story.url} styleName="title-link">
          {showSubHeading && story && story.subheadline && (
            <span className="sub-title" styleName="sub-title no-link">
              {String(story.subheadline).trim()}
            </span>
          )}

          {" " + String(storyHeadline || "").trim()}
        </Link>
      ) : (
        <span styleName="tilte-no-link-parent" className="tilte-no-link-parent">
          {showSubHeading && story && story.subheadline && (
            <span className="sub-title" styleName="sub-title no-link">
              {String(story.subheadline).trim()}
            </span>
          )}

          {" " + String(storyHeadline || "").trim()}
        </span>
      )}
    </Htag>
  );
};

NewsHeadline.propTypes = {
  cssStyleName: string,
  story: object,
  showDot: bool,
  styles: object,
  showSubHeading: bool,
  linkEnable: bool,
  Htag: string,
};

export default NewsHeadline;
